import {CustomerAddressType} from 'desktop/types/customerAddressesType';

type AddressComponentsType = {
    name: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    code: string;
    state: string;
    country: string;
};

/**
 * Format address
 * @param {CustomerAddressType} address - Customer address to decompose to components
 * @returns {AddressComponentsType} Processed address components
 */
export const getAddressComponents = (address: CustomerAddressType): AddressComponentsType => ({
    address: address.aptSuiteOther ? `${address.street} ${address.aptSuiteOther}` : address.street,
    city: address.city,
    code: address.zipCode,
    country: address.country,
    email: address.email,
    name: `${address.firstName} ${address.lastName}`,
    phone: address.phone,
    state: address.regionCode,
});
